import React from "react";

const SELECTS = [
  ["textWidth", "Text width", ["small", "medium", "large"]],
  ["contentWidth", "No-media content width", ["60%", "70%", "75%", "80%", "100%"]],
  ["mediaWidth", "Media width", ["narrow", "default", "wide"]],
  ["mediaSide", "Media side", ["right", "left"]],
  ["mediaTopGap", "Media top gap", ["none", "xs", "small", "medium", "large"]],
  ["mediaInset", "Media inset", ["none", "small", "medium"]],
  ["mediaMarginTop", "Media margin top", ["none", "xs", "small", "medium", "large"]],
  ["mediaMarginRight", "Media margin right", ["none", "xs", "small", "medium", "large"]],
  ["mediaMarginBottom", "Media margin bottom", ["none", "xs", "small", "medium", "large"]],
  ["mediaMarginLeft", "Media margin left", ["none", "xs", "small", "medium", "large"]],
  ["mediaFit", "Media fit", ["contain", "cover"]],
  ["mediaPosition", "Media position", ["center", "top", "bottom", "left", "right", "left-top", "right-top", "left-bottom", "right-bottom"]],
  ["mediaBackground", "Media background", ["default", "soft-blue", "none"]],
  ["leftBlend", "Left blend", ["none", "subtle", "standard", "strong"]],
  ["leftBlendWidth", "Left blend width", ["narrow", "default", "wide"]],
  ["topBlend", "Top blend", ["none", "subtle", "standard", "strong"]],
  ["topBlendHeight", "Top blend height", ["narrow", "default", "wide"]],
];

const HeroSettingsPanel = ({ settings, onChange, onReset, onDismiss, onCopyUrl, onCopyConfiguration }) => (
  <aside className="hero-settings" aria-label="Hero settings">
    <div className="hero-settings__heading">
      <strong>Hero settings</strong>
      <button type="button" onClick={onDismiss} aria-label="Dismiss Hero settings">×</button>
    </div>
    <div className="hero-settings__controls">
      {SELECTS.map(([name, label, options]) => (
        <label key={name}>{label}
          <select name={name} value={settings[name]} onChange={(event) => onChange(name, event.target.value)}>
            {options.map((option) => <option key={option} value={option}>{option}</option>)}
          </select>
        </label>
      ))}
      {[["mediaBleedRight", "Bleed right"], ["mediaBleedBottom", "Bleed bottom"], ["showRegions", "Show regions"]].map(([name, label]) => (
        <label className="hero-settings__toggle" key={name}>
          <input name={name} type="checkbox" checked={settings[name]} onChange={(event) => onChange(name, event.target.checked)} />
          {label}
        </label>
      ))}
    </div>
    <div className="hero-settings__actions">
      <button type="button" onClick={onCopyUrl}>Copy settings URL</button>
      <button type="button" onClick={onCopyConfiguration}>Copy configuration</button>
      <button type="button" onClick={onReset}>Reset</button>
    </div>
  </aside>
);

export default HeroSettingsPanel;
